import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import config from 'devextreme/core/config';
 import { App } from '~/app';
import { licenseKey } from '~/devextreme-license';
import './index.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import './app.scss';
import './dx-styles.scss';

config({ licenseKey });

const root = createRoot(document.getElementById('root'));

root.render(
  // <StrictMode>
    <App />
  // </StrictMode>
);